import { useContainer } from './use-container.hook';

// Define a hook to inject dependencies from the container
export const useInject = <T>(identifier: string) => {
  const container = useContainer();
  return container.resolve<T>(identifier);
};
